import { render, staticRenderFns } from "./MyAds.vue?vue&type=template&id=f2961510&scoped=true&"
import script from "./MyAds.vue?vue&type=script&lang=js&"
export * from "./MyAds.vue?vue&type=script&lang=js&"
import style0 from "./MyAds.vue?vue&type=style&index=0&id=f2961510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2961510",
  null
  
)

export default component.exports